/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Artcraft_V_InstallerInputs */

const en_home_artcraft_v_installer = /** @type {(inputs: Home_Artcraft_V_InstallerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ArtCraft Launcher`)
};

/**
* | output |
* | --- |
* | "ArtCraft Launcher" |
*
* @param {Home_Artcraft_V_InstallerInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const home_artcraft_v_installer = /** @type {((inputs?: Home_Artcraft_V_InstallerInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Artcraft_V_InstallerInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_home_artcraft_v_installer(inputs)
});
export { home_artcraft_v_installer as "home.artcraft.v_installer" }